module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Date field is required":"Date field is required","Date of birth":"Date of birth","day":"day","Day":"Day","Month":"Month","Year":"Year"},"it":{"Date field is required":"Date field is required","Date of birth":"Data di nascita","day":"giorno","Day":"Giorno","Month":"Mese","Year":"Anno"}}')
  delete Component.options._Ctor
}
